// PWA / display-mode helpers.

// True when the app is running as an installed PWA (launched from the home
// screen / app icon) rather than inside a browser tab. iOS Safari exposes
// the non-standard navigator.standalone; everywhere else the
// display-mode media query is authoritative.
//
// Why this matters: the browser Fullscreen API is unavailable in iOS
// standalone PWAs, so controls that call requestFullscreen() (e.g. Google
// Maps' native fullscreen button) hang and lock the UI. Callers use this
// to disable those controls in standalone mode while keeping them in the
// browser, where they work fine.
export const isStandalone = (): boolean => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (window.navigator as unknown as { standalone?: boolean }).standalone ===
      true
  );
};
